export interface FaqItem {
  q: string;
  a: string;
}

export const FAQ_ITEMS: FaqItem[] = [
  {
    q: "黑料档案到底收录了什么内容？",
    a: "我们把人品争议、感情纠纷、耍大牌、违约失信、言论翻车、行为失当等娱乐圈公开争议，按主题分类整理成结构化档案，并附带事件的时间线、涉及标签与全过程拆解，方便读者按需检索和了解来龙去脉。",
  },
  {
    q: "档案中的事件和信息一定属实吗？",
    a: "档案以网络公开报道与当事人公开发表内容为基础进行信息梳理，性质为舆情观察与娱乐信息整理，不代表任何司法定性。所有条目均标注分类与时间，读者应以权威司法机构和品牌方的官方披露为准，对未经证实的内容保持审慎。",
  },
  {
    q: "为什么要把黑料分成六大类？",
    a: "六大分类对应娱乐圈最常见的争议触发类型，既方便按关键词快速定位同类事件，也能帮助读者理解不同争议的发酵逻辑与风险层级——比如涉及法律红线的行为失当，和偏向观感评价的人品争议，处置路径完全不同。",
  },
  {
    q: "如何在网站上快速检索某类黑料？",
    a: "进入「分类档案库」后，可先在上方切换六大分类页签，再通过标签筛选或关键词搜索收窄结果。每个档案条目都带有一组细分标签，例如「撕前任」「直播口误」「酒驾斗殴」，点选后即可获得更精准的对应内容。",
  },
  {
    q: "档案多久更新一次？会不会跟进最新瓜？",
    a: "档案库持续关注娱乐热点动态，新事件会按分类即时入库并标记日期。读者也可以订阅每周黑料简报，或通过「我要爆料」提交线索，我们会优先核查后补充相关档案条目。",
  },
  {
    q: "如果认为某个条目内容有误，如何反馈纠错？",
    a: "你可以通过「关于我们」页面的线索投稿表单提交纠错说明，附上可核实的信息来源即可。核实后我们会及时修正或删除相关条目，并严格遵守公序良俗与信息真实性的编辑原则。",
  },
];